const hasPremiumAccess = me => {
  if (!me) return null;
  const { subscriptions, hasFullAccess } = me;
  if (hasFullAccess) return true;
  return !!subscriptions?.length && new Date(subscriptions[0].validUntil) > new Date();
};

export default hasPremiumAccess;
